import { GlButton, GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Tracking from '../../tracking/index.js?vue3';
export default {
    name: 'BoardAddNewColumnTrigger',
    components: {
        GlButton,
        GlIcon
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        isNewListShowing: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'set-add-column-form-visibility'
    ],
    methods: {
        handleClick () {
            this.$emit('set-add-column-form-visibility', true);
            this.track('click_button', {
                label: 'create_list'
            });
        }
    }
};
